import { useAppDispatch, useAppSelector } from "@/Hook/hooks";
import { getDataAnalyticsConfig } from "@/Redux/Ducks/dataAnalyticsSlice";
import { getScreenConfig } from "@/Redux/Ducks/entryFormSlice";
import { getReportConfig } from "@/Redux/Ducks/reportExplorerSlice";
import { ControlTranslation } from "AlignComponents";
import { Button, Card } from "react-bootstrap";
import { FaCog, FaTasks } from "react-icons/fa";
import { GoGoal } from "react-icons/go";

const MyGoals = () => {
  const dispatch = useAppDispatch();
  const goals = useAppSelector(x => x.Home.goals);

  const manageGoals = () => {
    dispatch(getScreenConfig({ processCode: "PRGO" }))
  }

  const manageGoal = (goal: string) => {
    dispatch(getScreenConfig({ processCode: "PRGO", transactionNo: goal }))
  }

  return (
    <div className="widget my-goals">
      <Card>
        <Card.Header>
          <Card.Title>
            <GoGoal size={18} className="icon" />
            <ControlTranslation system={true} controlId="lblmygoals" />
          </Card.Title>
          <Button variant="primary" className="ms-auto" onClick={manageGoals}>
            <FaCog size={12} className="me-2" />
            Manage
          </Button>
        </Card.Header>
        <Card.Body>
          <div className="tasks">
            {
              goals.map(x => (
                <div key={x.goalno} className="task">
                  <div>
                    <div className="text">
                      <h6>
                        {x.goalstxt}
                      </h6>
                      <span>
                        {x.details}
                      </span>
                    </div>
                    <div className="badge bg-success fs-8">
                      {x.goallevel}
                    </div>
                  </div>
                  <div className="ms-auto">
                    <div className="badge bg-outline-primary">
                      {x.status}
                    </div>
                  </div>
                  <Button variant="primary" className="ms-2 btn-sm" onClick={() => { manageGoal(x.goalno) }}>
                    <FaCog size={12} />
                  </Button>
                </div>
              ))
            }
          </div>
        </Card.Body>
      </Card>
    </div >
  )
};

export default MyGoals;